import { TooltipDialog, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { buttonIconCss, dialogCss } from "./ContentStatus.style";

const propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  text: PropTypes.string.isRequired,
  ariaProps: PropTypes.shape({
    "aria-label": PropTypes.string.isRequired,
  }).isRequired,
};

const ContentStatus = ({ icon, text, ariaProps }) => {
  return (
    <TooltipDialog
      placement="right"
      buttonProps={{
        flavor: Button.flavors.incognito,
        icon: { SvgComponent: icon },
      }}
      ariaProps={ariaProps}
      dialogAriaProps={ariaProps}
      __cssFor={{ Button: buttonIconCss, dialog: dialogCss }}
      body={text}
    />
  );
};

ContentStatus.propTypes = propTypes;

export default ContentStatus;
